<template>
  <div class="item-box--connected">
    <a :href="linkUrl" @click="onClickItemBox">
      <div class="item-card--connected">
        <div class="item-card-icon--connected">
          <ImgLazy
            :image-url="imageUrl"
            :alt-text="itemName"
            aspect-ratio="1 / 1"
          />
        </div>
        <div class="item-card-connected-info">
          <LabelChips :labels="labels" />
          <div class="item-card-connected__brand-name">
            {{ brandName }}
          </div>
          <div class="item-card-connected__item-name">
            {{ itemName }}
          </div>
          <div class="item-card-connected__item-prices">
            <span class="item-card-connected__currency-symbol">¥</span>
            <span class="item-card-connected__item-price">{{ itemPrice }}</span>
            <span v-if="isIncludingTax" class="item-card-connected__item-tax">
              税込
            </span>
            <span
              v-if="hasMultipleItemSkus"
              class="item-card-connected__item-skus"
            >
              {{ priceSuffix }}
            </span>
            <span v-if="soldOut" class="item-card-connected__sold-out">
              入荷待ち
            </span>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>
<script>
import ImgLazy from '../images/ImgLazy.vue'
import LabelChips from '../labels/LabelChips.vue'

export default {
  components: {
    ImgLazy,
    LabelChips
  },
  props: {
    linkUrl: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    brandName: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemPrice: {
      type: String,
      required: true
    },
    isIncludingTax: {
      type: Boolean,
      required: true
    },
    hasMultipleItemSkus: {
      type: Boolean,
      required: true
    },
    priceSuffix: {
      type: String,
      default: '~'
    },
    soldOut: {
      type: Boolean,
      required: false,
      default: false
    },
    labels: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  methods: {
    onClickItemBox() {
      this.$emit('click-item-box-connected')
    }
  }
}
</script>
<style lang="scss" scoped>
.label-chips {
  margin: 0 0 8px 0;
}
</style>
